<template>
  <div>
    <Loader
      v-show="loading"
      :loading="loading"
    />
    <v-card>
      <v-card-title>
        <v-row no-gutters>
          <span class="headline font-weight-medium">{{ header }}</span>
          <v-spacer />
          <IconBtn
            icons="close"
            :large="true"
            color="grey darken-4"
            @click="close"
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <CustomTextField
              v-model="title"
              label="Найменування"
              :hide-details="true"
              :required="true"
              :error-messages="$v.title.$invalid ? errors.TITLE : []"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="code"
              label="Код"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <PrimaryBtn
          :loading="loading"
          :disabled="!isChanged || isFormInvalid"
          @click="save"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import * as unitsApi from "../../backend/unitsApi.js";
import Loader from "../../../components/Loader.vue";
import IconBtn from "../../../components/IconBtn.vue";
import PrimaryBtn from "../../../components/PrimaryBtn.vue";
import CustomTextField from "../../../components/CustomTextField.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    Loader,
    IconBtn,
    PrimaryBtn,
    CustomTextField,
  },
  props: ["id"],
  data: () => ({
    loading: false,
    isChanged: false,
    title: "",
    code: "",
  }),
  validations: {
    title: {
      required,
    },
  },
  computed: {
    isFormInvalid(){
      return this.$v.title.$invalid;
    },
    isNew() {
      return this.id != 0 ? false : true;
    },
    header() {
      return this.isNew ? "Створення одиниці виміру" : "Редагування одиниці виміру";
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (this.id != 0) {
      unitsApi.getUnit(this.id).then((entity) => {
        this.title = entity.title;
        this.code = entity.code;
      });
    }
  },
  methods: {
    async save() {
      this.loading = true;

      const newEntity = {
        title: this.title,
        code: this.code,
      };

      if (this.id == 0) {
        await unitsApi
          .createUnit(newEntity)
          .then(() => {
            this.$router.push({ path: "/sales-units" });
          });
      } else {
        await unitsApi.updateUnit(this.id, newEntity);
        this.$notifySuccess();
      }
      this.loading = false;
    },
    close() {
      if (this.modal) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>